import { useEffect } from "react";
import { useAiStore } from "../store/aiStore";

export function useCommandBarShortcut() {
  const toggleCommandBar = useAiStore((s) => s.toggleCommandBar);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        toggleCommandBar();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [toggleCommandBar]);
}
